import { render, staticRenderFns } from "./FeedDesignators.vue?vue&type=template&id=66186b59"
import script from "./FeedDesignators.vue?vue&type=script&lang=js"
export * from "./FeedDesignators.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports